import { apiClient, httpCommunication } from "@uri/typed-api";
import { agentFomoDomain, apiUrlPath } from "../../constants.ts";
import { webApi } from "../../webApi.ts";
import { db } from "./db.ts";

const rawApi = apiClient(
  httpCommunication(`https://${agentFomoDomain}${apiUrlPath}`),
  webApi,
);

export const api = async <E extends keyof typeof webApi>(
  params: {
    endpoint: E;
    payload: typeof webApi[E]["input"]["_output"];
  },
): Promise<typeof webApi[E]["output"]["_output"]> => {
  const auth = await db.getAuth();
  const token = auth?.refresh_token;
  if (!token) {
    throw new Error("User not authenticated");
  }
  return rawApi({
    endpoint: params.endpoint,
    token,
    payload: params.payload,
  });
};
